import { useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxSchool from "../../../util/remote/ajaxSchool";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";

const UpdateTermDetails=(props)=>{

    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState(props.startDate);
    const [endDate, setEndDate] = useState(props.endDate);
    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(startDate.length>0 || endDate.length>0){
            setLoading(true)
            const server_response = await ajaxSchool.updateSchoolTerm(props.termID, startDate, endDate);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter all fields!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Update Term Details"
            id="model-update-term-details"
            size="md"
            footer={RenderFooter}
        >
            
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Start Date</label>
                <input onChange={(e)=>setStartDate(e.target.value)} style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
            </div>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">End Date</label>
                <input onChange={(e)=>setEndDate(e.target.value)} style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
            </div>
       
        </SystemModal>
    )
}

export default UpdateTermDetails
